<template>
  <div class="add-bid">
    <AddBidDropdown @command="switchModals" />

    <AddBidModal v-model="showSingleAddBidModal" />
  </div>
</template>

<script>
import { dropDownCommands } from './common/constant';
import AddBidDropdown from './AddBidDropdown';
import AddBidModal from '../../common/AddBidModal';

import { AD_CAMPAIGN_ADD_KEYWORD_BUTTON } from '@/constants/gtm-events';

export default {
  name: 'AddBid',
  components: {
    AddBidDropdown,
    AddBidModal,
  },
  data() {
    return {
      showSingleAddBidModal: false,
    };
  },
  computed: {
    dropDownCommands() {
      return dropDownCommands;
    },
  },
  methods: {
    switchModals(cmd) {
      if (cmd === dropDownCommands.ADD_SINGLE_BID) {
        this.showKeywordModal();
        return;
      }

      this.showSingleAddBidModal = false;
      this.$router.push({ name: 'search-ads-add-bulk-bids' });
    },
    showKeywordModal() {
      this.$gtm.trackEvent(AD_CAMPAIGN_ADD_KEYWORD_BUTTON);

      this.showSingleAddBidModal = true;
    },
  },
};
</script>
